module.exports = [{
      plugin: require('/Users/jpb/code/wip/elixir/madvoid.com/frontend-gatsby/node_modules/gatsby-plugin-nprogress/gatsby-browser'),
      options: {"plugins":[],"color":"#9622dd","showSpinner":false},
    },{
      plugin: require('/Users/jpb/code/wip/elixir/madvoid.com/frontend-gatsby/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[],"navigateFallback":null,"navigateFallbackWhitelist":[]},
    }]
